import { useLocation, useNavigate } from 'react-router-dom'

type Props = {
  currentPage: number
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>
  totalPage: number
}
/**
 * 페이지네이션 핸들러를 반환
 * @param currentPage 현재 페이지 (state)
 * @param setCurrentPage 현재 페이지 setter
 * @param totalPage
 */

const usePagination = ({ currentPage, setCurrentPage, totalPage }: Props) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const navigatePage = (page: number) => navigate(`${pathname}?page=${page}`)

  const onNext = () => {
    if (currentPage < totalPage) {
      setCurrentPage((currentPage) => currentPage + 1)
      navigatePage(currentPage + 1)
    }
  }

  const onPrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1)
      navigatePage(currentPage - 1)
    }
  }

  const onFirst = () => {
    setCurrentPage(1)
    navigatePage(1)
  }

  const onLast = () => {
    setCurrentPage(totalPage)
    navigatePage(totalPage)
  }

  return {
    onNext,
    onPrev,
    onFirst,
    onLast,
  }
}

export default usePagination
